'use client';

import { c as _c } from "react/compiler-runtime";
import { useContext, useMemo } from 'react';
import { useLFSearchParams } from '@services/useLFSearchParams';
import { useQueryOrg } from '@services/useQueryOrg';
import { RootStoreContext } from '@stores/rootStore';
import { ICropSummary } from '@stores/CropSummary';
import { isPresent } from '@farmai-shared/LFUtils';
export const useActiveCrop = () => {
  const $ = _c(21);
  const {
    uiStore,
    userStore
  } = useContext(RootStoreContext);
  const lang = userStore.user.settings.lang;
  const {
    searchParams,
    setParams
  } = useLFSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("filter[crop]");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const cropParam = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["overview", "crop summary"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== uiStore) {
    t2 = {
      queryKey: t1,
      queryFn: () => uiStore.currentOrganization?.fetchOrgStats().then(_temp),
      refetchOnWindowFocus: false
    };
    $[3] = uiStore;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: t3,
    isLoading
  } = useQueryOrg(t2);
  let t4;
  if ($[5] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const crops = t4;
  let t5;
  bb0: {
    if (!cropParam || !isPresent(crops?.length)) {
      t5 = null;
      break bb0;
    }
    let t6;
    if ($[7] !== cropParam || $[8] !== crops) {
      let t7;
      if ($[10] !== cropParam) {
        t7 = c => c.name === cropParam;
        $[10] = cropParam;
        $[11] = t7;
      } else {
        t7 = $[11];
      }
      t6 = crops.find(t7);
      $[7] = cropParam;
      $[8] = crops;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    const match = t6;
    t5 = match ?? null;
  }
  const activeCrop = t5;
  const activeCropLabel = activeCrop ? activeCrop.name_i18n[lang] : undefined;
  let t6;
  if ($[12] !== setParams) {
    t6 = next => {
      setParams([{
        key: "filter[crop]",
        value: next
      }]);
    };
    $[12] = setParams;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const setActiveCrop = t6;
  let t7;
  if ($[14] !== activeCrop || $[15] !== activeCropLabel || $[16] !== cropParam || $[17] !== crops || $[18] !== isLoading || $[19] !== setActiveCrop) {
    t7 = {
      cropParam,
      crops,
      activeCrop,
      activeCropLabel,
      isLoading,
      setActiveCrop
    };
    $[14] = activeCrop;
    $[15] = activeCropLabel;
    $[16] = cropParam;
    $[17] = crops;
    $[18] = isLoading;
    $[19] = setActiveCrop;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
function _temp(org) {
  return org.cropSummary;
}